var map = {
	"./06_camafeos/cam_10_off.png": "4c63",
	"./06_camafeos/cam_10_on.png": "c01a",
	"./06_camafeos/cam_1_off.png": "cb29",
	"./06_camafeos/cam_1_on.png": "d896",
	"./06_camafeos/cam_2_off.png": "d159",
	"./06_camafeos/cam_2_on.png": "aede",
	"./06_camafeos/cam_3_off.png": "15af",
	"./06_camafeos/cam_3_on.png": "93e6",
	"./06_camafeos/cam_4_off.png": "3ebb",
	"./06_camafeos/cam_4_on.png": "8592",
	"./06_camafeos/cam_5_off.png": "292b",
	"./06_camafeos/cam_5_on.png": "76b9",
	"./06_camafeos/cam_6_off.png": "ca2d",
	"./06_camafeos/cam_6_on.png": "e237",
	"./06_camafeos/cam_7_off.png": "2d30",
	"./06_camafeos/cam_7_on.png": "fba9",
	"./06_camafeos/cam_8_off.png": "6036",
	"./06_camafeos/cam_8_on.png": "fb82",
	"./06_camafeos/cam_9_off.png": "baa2",
	"./06_camafeos/cam_9_on.png": "dc0d",
	"./06_camafeos/cm_on.png": "7094",
	"./07_estrella/estrella_1.png": "7f0e",
	"./07_estrella/estrella_2.png": "d751",
	"./PNGBARRA_2024.png": "ad58",
	"./bocina.png": "b396",
	"./bocina_seleccion.png": "d3a7",
	"./boxIcon.png": "ae30",
	"./boxIconGray.png": "be32",
	"./btn_desc.png": "4d86",
	"./btn_foto.png": "4475",
	"./btn_girar.png": "8487",
	"./button/arrow.png": "8371",
	"./button/white-arrow.png": "2c75",
	"./camera.png": "c0b1",
	"./condesa_ra_3.png": "8f0e",
	"./desafio_galeria.png": "21a4",
	"./dots/on_selec1.png": "542d",
	"./dots/on_selec2.png": "abb0",
	"./dummyPoint.png": "8674",
	"./final_star.png": "4e8f",
	"./images/cascata_01.jpg": "632a",
	"./images/cascata_02.jpg": "2823",
	"./images/entrada_01.jpg": "5269",
	"./images/entrada_02.jpg": "bc63",
	"./images/escadaria_01.jpg": "0cd5",
	"./images/escadaria_02.jpg": "1023",
	"./images/feteira_01.jpg": "9db1",
	"./images/int1_ent_cas_01.jpg": "7dc1",
	"./images/int2_cas_fet_01.jpg": "9c2a",
	"./images/int3_fet_rui_01.jpg": "280b",
	"./images/int4_rui_lag_01.jpg": "775f",
	"./images/int4_rui_lag_02.jpg": "aebd",
	"./images/int6_jar_ros_01.jpg": "cfce",
	"./images/int7_ros_rel_01.jpg": "d76e",
	"./images/int7_ros_rel_02.jpg": "da9b",
	"./images/int8_rel_esc_01.jpg": "e909",
	"./images/int8_rel_esc_02.jpg": "78f5",
	"./images/int9_esc_pal_01.jpg": "6008",
	"./images/jardimmx_01.jpg": "c734",
	"./images/jardimmx_02.jpg": "d57b",
	"./images/lagos_01.jpg": "a020",
	"./images/lagos_02.jpg": "e0e6",
	"./images/palacio_01.jpg": "0913",
	"./images/palacio_02.jpg": "3d5a",
	"./images/palacio_03.jpg": "d866",
	"./images/palacio_04.jpg": "15fe",
	"./images/relvado_01.jpg": "4e9d",
	"./images/relvado_02.jpg": "3bf2",
	"./images/roseiral_01.jpg": "cbe1",
	"./images/roseiral_02.jpg": "f2fd",
	"./images/ruina_01.jpg": "9620",
	"./info/Intersect@2x-1.png": "07bc",
	"./info/Intersect@2x.png": "5fc6",
	"./info/Screenshot 2021-09-17 at 12.51 1@2x.jpg": "6496",
	"./mapas/mapa_en (2).jpg": "245e",
	"./mapas/mapa_en.jpg": "179b",
	"./mapas/mapa_es (2).jpg": "0580",
	"./mapas/mapa_es.jpg": "5b8a",
	"./mapas/mapa_fr.jpg": "557f",
	"./mapas/mapa_pt (2).jpg": "97b5",
	"./mapas/mapa_pt.jpg": "e940",
	"./next.png": "2952",
	"./patrimonio-animation-en.mp4": "d7b9",
	"./patrimonio-animation-es.mp4": "0ad0",
	"./patrimonio-animation-pt.mp4": "c018",
	"./pena_logo.png": "9432",
	"./pin.png": "56a2",
	"./pinTest.png": "bc9d",
	"./prev.png": "2fbf",
	"./progress/barra_10_0.png": "e81a",
	"./progress/barra_10_1.png": "0422",
	"./progress/barra_10_10.png": "3775",
	"./progress/barra_10_2.png": "b941",
	"./progress/barra_10_3.png": "f6ac",
	"./progress/barra_10_4.png": "739c",
	"./progress/barra_10_5.png": "50f8",
	"./progress/barra_10_6.png": "6bda",
	"./progress/barra_10_7.png": "e53a",
	"./progress/barra_10_8.png": "7f89",
	"./progress/barra_10_9.png": "5d6b",
	"./progress/star_off.png": "c6b60",
	"./progress/star_on.png": "c7b1",
	"./puzzlefotos/relvado/1.png": "3c38",
	"./puzzlefotos/relvado/10.png": "7093",
	"./puzzlefotos/relvado/11.png": "d6bf",
	"./puzzlefotos/relvado/12.png": "1b68",
	"./puzzlefotos/relvado/2.png": "9019",
	"./puzzlefotos/relvado/3.png": "0674",
	"./puzzlefotos/relvado/4.png": "34b4",
	"./puzzlefotos/relvado/5.png": "42ab",
	"./puzzlefotos/relvado/6.png": "7e38",
	"./puzzlefotos/relvado/7.png": "d94c",
	"./puzzlefotos/relvado/8.png": "08de",
	"./puzzlefotos/relvado/9.png": "8c14",
	"./puzzlefotos/relvado/full_segmented.png": "1ffe",
	"./puzzlefotos/relvado/relvado_en.jpg": "68af",
	"./puzzlefotos/relvado/relvado_es.jpg": "304f",
	"./puzzlefotos/relvado/relvado_fr.jpg": "cd4e",
	"./puzzlefotos/relvado/relvado_pt.jpg": "fcb0",
	"./puzzlefotos/relvado/separados/1.png": "b6d6",
	"./puzzlefotos/relvado/separados/10.png": "7d65",
	"./puzzlefotos/relvado/separados/11.png": "de8c",
	"./puzzlefotos/relvado/separados/12.png": "1534",
	"./puzzlefotos/relvado/separados/2.png": "f947",
	"./puzzlefotos/relvado/separados/3.png": "4dcc",
	"./puzzlefotos/relvado/separados/4.png": "a598",
	"./puzzlefotos/relvado/separados/5.png": "8c5a",
	"./puzzlefotos/relvado/separados/6.png": "9146",
	"./puzzlefotos/relvado/separados/7.png": "31a0",
	"./puzzlefotos/relvado/separados/8.png": "822b",
	"./puzzlefotos/relvado/separados/9.png": "ebaf",
	"./queluz_logo.png": "4d74",
	"./ruta_final.png": "79b4",
	"./ruta_inicio.png": "c13a",
	"./tap@3x.png": "5569",
	"./triviafotos/lagos/op1.png": "3b88",
	"./triviafotos/lagos/op2.png": "1407",
	"./triviafotos/lagos/op3.png": "3338",
	"./triviafotos/lagos/op4.png": "e423",
	"./triviafotos/roseiral/1.png": "c9f4",
	"./triviafotos/roseiral/2.png": "e50d",
	"./triviafotos/roseiral/3.png": "66ae",
	"./triviafotos/roseiral/4.png": "ce23",
	"./triviafotos/vale/1.png": "72ec",
	"./triviafotos/vale/2.png": "d546",
	"./triviafotos/vale/3.png": "5cb8",
	"./triviafotos/vale/4.png": "7906",
	"./ubicacion.png": "5755"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";